import { perspectives as Perspectives } from 'collections/perspectives';
import { backboneDispatchers as subscribeToFilters } from 'streams/filters/backboneDispatchers';

export function startBackboneDispatchers() {
  subscribeToFilters(Perspectives);
}
